<template>
    <div class="afterSales">
        <div class="afterSales-banner">
            <div class="main_content">
                <div class="afterSales-banner-title">快麦打印机售后服务中心</div>
            </div>
        </div>
        <div class="afterSales-content afterSales-content-white">
            <div class="main_content">
                <div class="afterSales-content-title">保修政策</div>
                <div class="afterSales-repair-text">
                    由快麦官方渠道所售出产品，凡属于正常使用情况下由于产品本身质量问题所引起的故障，保修期限范围内的机器将不收取费用，我司负责免费维修。
                </div>
                <div class="table-content">
                    <table>
                        <tr>
                            <th>设备类型</th>
                            <th>保修类型</th>
                            <th>保修时间</th>
                        </tr>
                        <tr>
                            <td>打印机</td>
                            <td>打印头</td>
                            <td>打印长度30公里或出厂时3个月 ，先到为准</td>
                        </tr>
                        <tr>
                            <td>打印机</td>
                            <td>打印机机身（除打印头）</td>
                            <td>12个月</td>
                        </tr>
                        <tr>
                            <td>打印机</td>
                            <td>电池</td>
                            <td>6个月</td>
                        </tr>
                        <tr>
                            <td>打印机</td>
                            <td>电源适配器</td>
                            <td>3个月</td>
                        </tr>
                        <tr>
                            <td>打印机</td>
                            <td>数据线</td>
                            <td>3个月</td>
                        </tr>
                        <tr>
                            <td>智能设备PDA</td>
                            <td>机器整机（除电池）</td>
                            <td>12个月</td>
                        </tr>
                    </table>
                </div>
                <div class="afterSales-content-subtitle">文本下列情况不属于保修范围內：</div>
                <div class="afterSales-repair-list">
                    1、未按产品使用说明的要求使用、维护、保管而造成损坏的。<br/>
                    2、购买后发生的，摔落、进水、不适当存放而造成损坏的。<br/>
                    3、设备在客户送修运输途中，由于包装不当或运输原因造成的损坏。<br/>
                    4、客户对产品上的序列号进行人为涂改，破损而导致无法辨认的。<br/>
                    5、对保修内的产品私自进行组装或维修而造成的损坏。<br/>
                    6、由于天灾等认为不可抗之自然灾害，异常电压等外部原因引导起的故障。
                </div>
                <div class="afterSales-content-title">维修价格表</div>
                <div class="table-content">
                    <table>
                        <tr>
                            <th>设备类型</th>
                            <th>故障类型</th>
                            <th>维修配件</th>
                            <th style="width: 600rem;">适用机型</th>
                            <th>维修报价（含税元/个）</th>
                        </tr>
                        <tr>
                            <td rowspan="14">打印机</td>
                            <td>打印头</td>
                            <td>3寸打印头</td>
                            <td>
                                KM202M/202MBT，KM118M,KM202M(NEW),KM106M,KM202Q ，
                                KM202MD/202MDB，K18/K18BT，,KM202MQ,DP358，KM218M系列（218MGC/218MGD/218MS/218MD等），KM218M/KM218ME打印头，360A/B系列
                            </td>
                            <td>140</td>
                        </tr>
                        <tr>
                            <td>打印头</td>
                            <td>4寸打印头</td>
                            <td>KM118D系列/4寸打印头KM-202D/202DB，K28/K28BT、老款KM202系列、京瓷打印头</td>
                            <td>190</td>
                        </tr>
                        <tr>
                            <td>打印头</td>
                            <td>4寸高清dpi打印头</td>
                            <td>
                                新旧款：KM118HD、KM118HD（NEW）/KM118DHD/KM118HBD/KM106HD
                            </td>
                            <td>350</td>
                        </tr>
                        <tr>
                            <td>主板</td>
                            <td>4寸主板（U）</td>
                            <td>
                                KM-118系列，KM-218，KM-100/100S，KM202，KM118D,KM-106,RX106,KM-202D，K28，KM202
                            </td>
                            <td>220</td>
                        </tr>
                        <tr>
                            <td>主板</td>
                            <td>4寸主板（蓝牙U）</td>
                            <td>KM-118BT，KM-218BT，KM-202DB，K28BT，KM202BT，KM202BT</td>
                            <td>230</td>
                        </tr>
                        <tr>
                            <td>主板</td>
                            <td>4寸主板（Wi-Fi/4gU）</td>
                            <td>
                                KM118DW
                            </td>
                            <td>280</td>
                        </tr>
                        <tr>
                            <td>主板</td>
                            <td>4寸主板高清</td>
                            <td>
                                KM118HD(NEW）/118DHD
                            </td>
                            <td>230</td>
                        </tr>
                        <tr>
                            <td>主板</td>
                            <td>3寸主板( 蓝牙U-便携式)</td>
                            <td>
                                KM202M,KM118M,KM218M,KM106M,KM202M（NEW）,KM202MD/K18,KM300,KM360,KM360A/B
                            </td>
                            <td>170</td>
                        </tr>
                        <tr>
                            <td>主板</td>
                            <td>3寸主板蓝牙U-桌面式</td>
                            <td>
                                KM202MBT,KM118MBT,KM218M,KM106MBT,KM202MBT（NEW）,KM202MDB/K18B
                            </td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>主板</td>
                            <td>3寸主板（Wi-Fi/4gU）</td>
                            <td>
                                KM118MW,SC318A,KM218MGD/218MGC,KM202MGD/202MGC
                            </td>
                            <td>220</td>
                        </tr>
                        <tr>
                            <td>适配器</td>
                            <td>4寸适配器</td>
                            <td>(包含大井适配器）</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>适配器</td>
                            <td>3寸适配器</td>
                            <td>亨讯电源适配器
                                24V,KM218M/KM218ME适配器,DP358适配器,SC310/SX320适配器,KM218MS适配器9V/KM218MD/LZ001D适配器24V
                            </td>
                            <td>65</td>
                        </tr>
                        <tr>
                            <td>适配器</td>
                            <td>碳带机-适配器</td>
                            <td>碳带机-适配器</td>
                            <td>85</td>
                        </tr>
                        <tr>
                            <td>数据线</td>
                            <td>数据线</td>
                            <td></td>
                            <td>20</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="afterSales-content afterSales-content-gray">
            <div class="main_content">
                <div class="afterSales-content-title">售后网点</div>
                <div class="afterSales-repair-text">
                    快麦打印机六大维修中心，提供快麦官方售后服务；由于不同维修站服务设备不同，可查询维修地址。
                </div>
                <div class="afterSales-repair-site">
                    <div class="afterSales-repair-site-item" v-for="repairSite in repairSiteList"
                         :key="repairSite.name">
                        <img src="./images/repair.png" alt="site">
                        {{ repairSite.name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="afterSales-content afterSales-content-white">
            <div class="main_content">
                <div class="afterSales-content-title">服务与支持</div>
                <div class="afterSales-repair-service">
                    <div class="afterSales-repair-service-item">
                        <img src="./images/icon1.png" alt="site">
                        <div class="afterSales-repair-service-item-title">在线报修</div>
                        <div class="afterSales-repair-service-item-text"
                             @click="openNew('https://casket.kuaimai.com/support/repair.html')">立即报修 >
                        </div>
                    </div>
                    <div class="afterSales-repair-service-item">
                        <img src="./images/icon2.png" alt="site">
                        <div class="afterSales-repair-service-item-title">查询寄件地址</div>
                        <div class="afterSales-repair-service-item-text"
                             @click="openNew('https://kuaimai.fanqier.cn/f/pociul7k')">立即查询 >
                        </div>
                    </div>
                    <div class="afterSales-repair-service-item">
                        <img src="./images/icon3.png" alt="site">
                        <div class="afterSales-repair-service-item-title">维修查询</div>
                        <div class="afterSales-repair-service-item-text"
                             @click="openNew('https://casket.kuaimai.com/support/repair.html')">立即查询 >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AfterSalesRepair",
    data() {
        return {
            repairSiteList: [
                {
                    name: '义乌维修点',
                    url: ''
                },
                {
                    name: '济南维修点',
                    url: ''
                },
                {
                    name: '上海维修点',
                    url: ''
                },
                {
                    name: '武汉维修点',
                    url: ''
                },
                {
                    name: '成都维修点',
                    url: ''
                },
                {
                    name: '佛山维修点',
                    url: ''
                },
            ]
        };
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../afterSales.scss";

.afterSales {
    .afterSales-repair-text {
        margin-top: 10rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16rem;
        color: #333333;
        line-height: 22rem;
    }

    .table-content {
        padding: 24rem 0;

        table {
            box-sizing: border-box;
            width: 100%;
            border-top: 1px solid #CCCCCC;
            border-left: 1px solid #CCCCCC;

            tr {
                background: #fff;

                &:nth-child(odd) {
                    background: #F9F9F9;
                }

                th {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 14rem;
                    color: #333333;
                    border-right: 1px solid #CCCCCC;
                    border-bottom: 1px solid #CCCCCC;
                    text-align: center;
                    line-height: 20rem;
                    padding: 24rem 0;
                    vertical-align: middle;
                }

                td {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14rem;
                    color: #333333;
                    border-right: 1px solid #CCCCCC;
                    border-bottom: 1px solid #CCCCCC;
                    text-align: center;
                    line-height: 20rem;
                    padding: 24rem 0;
                    vertical-align: middle;
                }
            }
        }
    }

    .afterSales-content-subtitle {
        margin-bottom: 11rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18rem;
        color: #333333;
        line-height: 25rem;
    }

    .afterSales-repair-list {
        margin-bottom: 40rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14rem;
        color: #333333;
        line-height: 32rem;
    }

    .afterSales-repair-site {
        padding: 30rem 0;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 32rem;

        .afterSales-repair-site-item {
            box-sizing: border-box;
            padding: 16rem 24rem;
            width: 380rem;
            background: #FFFFFF;
            border-radius: 20rem;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 24rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 24rem;
            color: #333333;

            &:hover {
                box-shadow: -2rem 0 0 0 #FD6520;
            }

            img {
                width: 88rem;
                height: 88rem;
            }
        }
    }

    .afterSales-repair-service {
        margin-top: 24rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .afterSales-repair-service-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 380rem;
            height: 320rem;
            background: #F2F3F5;
            border-radius: 20rem;

            img {
                height: 87rem;
            }

            .afterSales-repair-service-item-title {
                margin-top: 30rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 24rem;
                color: #333333;
                line-height: 33rem;
            }

            .afterSales-repair-service-item-text {
                margin-top: 10rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 16rem;
                color: #FD6520;
                line-height: 22rem;
                cursor: pointer;
            }
        }
    }
}
</style>
